import { createContext, useContext } from "react";

import { VisualizerSessionInfo } from "../features/DataVisualizer/DataVisualizer";

interface VisualizerContextInterface {
  isVisualizerModalOpen: boolean;
  setIsVisualizerModalOpen: (
    value: boolean | ((prev: boolean) => boolean),
  ) => void;
  visualizerInfo: VisualizerSessionInfo;
  setVisualizerInfo: (
    value:
      | VisualizerSessionInfo
      | ((prev: VisualizerSessionInfo) => VisualizerSessionInfo),
  ) => void;
}

const emptyVisualizerInfo: VisualizerSessionInfo = {
  playerName: "",
  orgPlayerId: "",
  domHand: "",
  sessionId: "",
  sessionDate: "",
};

const defaultVisualizerState = {
  isVisualizerModalOpen: false,
  setIsVisualizerModalOpen: (): boolean => false,
  visualizerInfo: emptyVisualizerInfo,
  setVisualizerInfo: (): VisualizerSessionInfo => emptyVisualizerInfo,
};

const VisualizerContext = createContext<VisualizerContextInterface>(
  defaultVisualizerState,
);

export const useVisualizerContext = (): VisualizerContextInterface =>
  useContext(VisualizerContext);

export default VisualizerContext;
